import React from 'react';
import { LoanPipeline } from './src/components/LoanPipeline';
export function App() {
  return <LoanPipeline data-id="element-0" />;
}